import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import * as Styles from './download-page-title.module.scss'
import { PageTitle } from '@/components/general/page-title'

export function DownloadPageTitle({ title, en, readText, ipo = false }) {
  return (
    <PageTitle
      title={title}
      en={en}
      decorationLogo
      readText={readText}
      ipo={ipo}
    >
      <div className={Styles.pageTitle_decoration_1}>
        {!ipo ? (
          <StaticImage
            src="../../images/page-title_image_download.png"
            height={141.07}
          />
        ) : (
          <StaticImage
            src="../../images/page-title_image_download_ipo.png"
            height={141.07}
          />
        )}
      </div>
    </PageTitle>
  )
}
